module.exports = __webpack_public_path__ + "img/icon_copy.ea06e11d.png";